import { render } from "./OverlayComponent.vue?vue&type=template&id=4f582ebd&scoped=true"
import script from "./OverlayComponent.vue?vue&type=script&lang=js"
export * from "./OverlayComponent.vue?vue&type=script&lang=js"

import "./OverlayComponent.vue?vue&type=style&index=0&id=4f582ebd&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f582ebd"]])

export default __exports__